var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-login-input.ts
import { ChemistryLiteElement } from "@adornis/chemistry/chemistry-lite-element";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token";
import { inputResetStyle } from "@adornis/forms/x-plain-input";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
var ElementsLoginInput = class extends ChemistryLiteElement {
  constructor() {
    super(...arguments);
    this.visible = false;
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return [
      inputResetStyle,
      {
        height: "unset",
        fontSize: this.baseFontSize,
        "--placeholder-color": this.colors?.neutral_800,
        cursor: "text",
        [`${DesignSystem.prefix}-flex[input-wrapper]`]: {
          ...this.inputToken,
          padding: `${this.spacing.xs} ${this.inputToken.paddingRight} ${this.spacing.xs} ${this.inputToken.paddingLeft}`,
          height: `calc(${this.baseFontSize}px + ${this.inputToken.paddingTop} + ${this.inputToken.paddingBottom} + 2px)`
        },
        "[visibility]": {
          margin: `-${this.inputToken.paddingTop} -${this.inputToken.paddingRight} -${this.inputToken.paddingBottom} -${this.spacing.sm}`,
          padding: `${this.inputToken.paddingTop} ${this.inputToken.paddingRight} ${this.inputToken.paddingBottom} ${this.spacing.sm}`,
          cursor: "pointer"
        },
        "[visibility][on] [vis-off]": { display: "none" },
        "[visibility][off] [vis]": { display: "none" }
      }
    ];
  }
  render() {
    return html`
      <x-flex input-wrapper horizontal crossaxis-center space="sm" @click=${() => this._input?.focus()}>
        <input
          ${ref((e) => this._input = e)}
          ${injectAttributesOf(this)}
          @input=${(e) => this.dispatchEvent(
      new CustomEvent("value-changed", { detail: { value: e.currentTarget.value } })
    )}
          @search=${(e) => this.dispatchEvent(
      new CustomEvent("value-changed", { detail: { value: e.currentTarget.value } })
    )}
          @keyup="${(e) => {
      if (e.key === "Enter")
        return this.dispatchEvent(
          new CustomEvent("submit", {
            detail: { value: e.currentTarget.value },
            composed: true,
            bubbles: true
          })
        );
      if (e.key === "Escape")
        return this.dispatchEvent(new CustomEvent("escape"));
    }}"
          @blur=${(e) => {
      this.dispatchEvent(
        new CustomEvent("value-picked", { detail: { value: e.currentTarget.value } })
      );
    }}
        />
        ${this._visibilityIcon()}
      </x-flex>
    `;
  }
  _visibilityIcon() {
    if (this.getAttribute("type") === "password")
      return html`
        <x-flex
          visibility
          off
          @click=${(e) => {
        const element = e.currentTarget;
        if (!element)
          return console.warn("click without currentTarget?");
        this.visible = !this.visible;
        if (this.visible) {
          element.removeAttribute("off");
          element.setAttribute("on", "");
          this._input?.setAttribute("type", "text");
        } else {
          element.removeAttribute("on");
          element.setAttribute("off", "");
          this._input?.setAttribute("type", "password");
        }
      }}
        >
          <x-icon vis> visibility_on </x-icon>
          <x-icon vis-off> visibility_off </x-icon>
        </x-flex>
      `;
    return nothing;
  }
};
ElementsLoginInput = __decorateClass([
  customElement("x-login-input")
], ElementsLoginInput);
export {
  ElementsLoginInput
};
